import favoriteIcon from '../assets/images/places/favorite-white.svg';
import homeIcon from '../assets/images/places/home-white.svg';
import workIcon from '../assets/images/places/work-white.svg';
import { FavoriteIcon, HomeIcon, WorkIcon } from '../components/icons';
import { Place } from './place';
export class User {
  constructor(id, email, username, birthDate, firstName, lastName, isAdmin, isSupport, isStaff, options, parameters, created, phoneNumber, profilePicture, employees) {
    this.id = id;
    this.email = email;
    this.username = username;
    this.birthDate = birthDate;
    this.firstName = firstName;
    this.lastName = lastName;
    this.isAdmin = isAdmin;
    this.isSupport = isSupport;
    this.isStaff = isStaff;
    this.options = options;
    this.parameters = parameters;
    this.created = created;
    this.phoneNumber = phoneNumber;
    this.profilePicture = profilePicture;
    this.employees = employees;
  }
  get pseudo() {
    return this.username ? this.username : !!this.firstName && !!this.lastName ? this.firstName + '_' + this.lastName : this.email;
  }
  get isGeovelo() {
    return this.email.indexOf('@geovelo.fr') > -1;
  }
  get isEcoCompteur() {
    return this.email.indexOf('@eco-counter.com') > -1 || this.email.indexOf('@eco-compteur.com') > -1;
  }
  clone() {
    return new User(this.id, this.email, this.username, this.birthDate, this.firstName, this.lastName, this.isAdmin, this.isSupport, this.isStaff, this.options, this.parameters, this.created, this.phoneNumber, this.profilePicture, this.employees);
  }
}
export const userPlaceTypes = {
  home: {
    Icon: HomeIcon,
    icon: homeIcon,
    titleKey: 'commons.favorites.places.home',
    color: '#dd428d'
  },
  other: {
    Icon: FavoriteIcon,
    icon: favoriteIcon,
    color: '#da6c2e'
  },
  work: {
    Icon: WorkIcon,
    icon: workIcon,
    titleKey: 'commons.favorites.places.work',
    color: '#dd428d'
  },
  transportModeChange: {
    Icon: FavoriteIcon,
    icon: favoriteIcon,
    color: '#da6c2e'
  }
};
export class UserPlace extends Place {
  constructor(id, type, title, point, address, created,
  // Only populated for work places — the commuting trips already linking this work to a home.
  commutingTripsToThisWork) {
    super(id, point, {
      primaryText: address
    });
    this.type = type;
    this.title = title;
    this.created = created;
    this.commutingTripsToThisWork = commutingTripsToThisWork;
  }
  clone() {
    return new UserPlace(this.id, this.type, this.title, {
      ...this.point
    }, this.address, this.created, this.commutingTripsToThisWork);
  }
}
export class UserRide {
  constructor(rideId, created) {
    this.rideId = rideId;
    this.created = created;
  }
}
export class UserChallenge {
  constructor(challenge, progressValue, rank, leaderboardIndex, subgroupsLeaderboards) {
    this.challenge = challenge;
    this.progressValue = progressValue;
    this.rank = rank;
    this.leaderboardIndex = leaderboardIndex;
    this.subgroupsLeaderboards = subgroupsLeaderboards;
  }
}
export class UserReferenceTrip {
  constructor(id, created, title, home, work, distanceHomeWork, distanceWorkHome, enabled) {
    this.id = id;
    this.created = created;
    this.title = title;
    this.home = home;
    this.work = work;
    this.distanceHomeWork = distanceHomeWork;
    this.distanceWorkHome = distanceWorkHome;
    this.enabled = enabled;
  }
}
export class UserReferenceTripOccurrence {
  constructor(id, userReferenceTripId, created, date, day, certifiedByGeovelo, manuallyCreated, comment, direction, hasUserTrace, enabled) {
    this.id = id;
    this.userReferenceTripId = userReferenceTripId;
    this.created = created;
    this.date = date;
    this.day = day;
    this.certifiedByGeovelo = certifiedByGeovelo;
    this.manuallyCreated = manuallyCreated;
    this.comment = comment;
    this.direction = direction;
    this.hasUserTrace = hasUserTrace;
    this.enabled = enabled;
  }
  get certified() {
    return this.certifiedByGeovelo;
  }
}